import { render, staticRenderFns } from "./Autonomous.vue?vue&type=template&id=61a2f2fe&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61a2f2fe')) {
      api.createRecord('61a2f2fe', component.options)
    } else {
      api.reload('61a2f2fe', component.options)
    }
    module.hot.accept("./Autonomous.vue?vue&type=template&id=61a2f2fe&", function () {
      api.rerender('61a2f2fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/icons/Autonomous.vue"
export default component.exports